(function () {
  const STORAGE_KEY = 'newsletter_popup_closed';
  const DELAY_MS = 1500;

  function getRoot() {
    return document.getElementById('NewsletterPopup-root');
  }

  function isClosedThisSession() {
    try {
      return sessionStorage.getItem(STORAGE_KEY) === '1';
    } catch {
      return false;
    }
  }

  function setClosedThisSession() {
    try {
      sessionStorage.setItem(STORAGE_KEY, '1');
    } catch {}
  }

  function open() {
    const root = getRoot();
    if (!root) return;
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    const firstFocusable = root.querySelector('input, button:not(.newsletter-popup__close)');
    if (firstFocusable) setTimeout(function () { firstFocusable.focus(); }, 100);
  }

  function close() {
    const root = getRoot();
    if (!root) return;
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    setClosedThisSession();
  }

  function init() {
    const root = getRoot();
    if (!root || isClosedThisSession()) return;

    const closers = root.querySelectorAll('[data-newsletter-popup-close]');
    closers.forEach(function (el) {
      el.addEventListener('click', close);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (!root.classList.contains('is-open')) return;
      close();
    });

    setTimeout(open, DELAY_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
